module.exports = __webpack_public_path__ + "media/images/common-nav/national-parks/grand_teton_national_park-95e622f6cec803bfb86aee6866c6ecac.jpg";